import { Link } from 'react-router-dom';
import { UserMenu } from './UserMenu';
import { LanguageSwitcher } from './LanguageSwitcher';
import './header.css';
import '../../i18n/config';

export const Header = () => {
	return (
		<header className="App-header">
			<div className="header-left">
				<Link to="/" className="logo-link">
					<img className="aegirLogo" src={'/DIGITU_logo.png'} alt="Digitu Logo" />
				</Link>
			</div>

			<div className="header-right">
				<LanguageSwitcher />
				<UserMenu />
			</div>
		</header>
	);
};
